import React from "react";
import { Dialog, DialogTitle, DialogContent, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { GroupedOffer } from "../types";

type Props = {
  open: boolean;
  onClose: () => void;
  offer: GroupedOffer;
};

const OfferInfoModal: React.FC<Props> = ({ open, onClose, offer }) => {
  const steamAccount = offer.steamAccount;
  const itemName = offer.item?.catalog.marketHashName ?? "Unknown Item";
  const price = typeof offer.price === "number" ? offer.price : null;
  const creationDate = offer.offerCreationDate
      ? new Date(offer.offerCreationDate)
      : null;
  const quantity = offer.offers?.length ?? 0;
  const floatValue = offer.item?.details?.floatValue ?? null;

  return (
      <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
        <div className="relative">
          <DialogTitle>Offer Info</DialogTitle>
          <IconButton onClick={onClose} className="!absolute right-3 top-3">
            <CloseIcon />
          </IconButton>
        </div>

        <DialogContent className="space-y-2 text-sm">

          <div>
            <strong>Item:</strong> {itemName}
          </div>

          <div>
            <strong>Price:</strong>{" "}
            {price !== null ? `${price.toFixed(2)} €` : "-"}
          </div>

          <div>
            <strong>Created:</strong>{" "}
            {creationDate ? creationDate.toLocaleString() : "-"}
          </div>

          <div>
            <strong>Quantity:</strong> {quantity}
          </div>

          <div>
            <strong>Float:</strong>{" "}
            {floatValue !== null ? floatValue.toFixed(4) : "-"}
          </div>

          <div>
            <strong>Steam User:</strong>{" "}
            {steamAccount?.name ?? "Unknown"}
          </div>

          {steamAccount?.url && (
              <div>
                <a
                    href={steamAccount.url}
                    target="_blank"
                    rel="noreferrer"
                    className="text-blue-400 hover:text-blue-300"
                >
                  Open Steam Profile
                </a>
              </div>
          )}

        </DialogContent>
      </Dialog>
  );
};

export default OfferInfoModal;
